var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inventory" },
    [
      _c("div", { staticClass: "page_title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: {
            width: "100%",
            "min-height": "calc(100vh - 400px)",
            "margin-bottom": "92px"
          },
          attrs: { data: _vm.tableData, stripe: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "table-name" },
                      [
                        _c("el-image", {
                          staticClass: "pro-image",
                          attrs: { src: scope.row.imgPath, fit: "cover" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.skuName))])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createBy", label: "Created", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$tool.formatDateTime(scope.row.createAt)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "type", label: "Reason", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.type === 1 ? "In-warehouse" : "Ex-warehouse"
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "num", label: "Qty", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.type === 1
                      ? _c("div", [_vm._v("+ " + _vm._s(scope.row.num))])
                      : _c("div", [_vm._v("- " + _vm._s(scope.row.num))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "balanceNum", label: "Inventory", width: "200" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tableData.length > 0
        ? _c(
            "div",
            { staticClass: "page_table" },
            [
              _c("pagination", {
                attrs: {
                  currentPage: _vm.pageConfigs.current_page,
                  total: _vm.total,
                  pageSize: _vm.pageConfigs.page_size
                },
                on: {
                  handleSizeChange: _vm.handleSizeChange,
                  handleCurrentChange: _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16a39046", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a39046","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/produts/sku-inventory.vue
// module id = gYRY
// module chunks = 2